// Module
var code = `<div on-mousedown="@this.onMouseDown(event)"
     on-click="@this.private_BtnClick(this)"
     class="{{.elementStyle}}{{isMenuShown ? ' active' : ''}} {{.additionalClass}}"
     as-tooltip="tooltip"
     style="{{>visibility}} {{#if isPosAbsolute}}position: absolute; {{>position}}{{/if}}"
     {{#.focused}} focused="" {{/}}
     {{#if !(.enabled) || !(.items.length)}} disabled="" {{/if}}>

     {{#if .useSVGView}}
     <svg>
         <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{.name}}"></use>
     </svg>
     {{else}}
     <div {{#.usePNGView}} style="height:100%; width:100%;" class="{{.selectedItem.style}} {{.updateComboBoxClass}}" {{/}}>
         {{^.usePNGView}}
             {{.selectedItem}}
         {{/}}
     </div>
    {{/if}}
 

    <div class="js-combobox-right-container">
        <div class="js-combobox-arrow-down" {{^.showArrow}} style="display: none;" {{/}}>
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#ArrowDown"></use>
            </svg>
        </div>
    </div>
</div>`;
// Exports
export default code;